import React, { useState } from "react";
import logo from "../../images/logo.png";
import { LuMenu } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const menu = [
  {
    name: "Free Bet codes",
    path: "/",
  },
  {
    name: "My Bets",
    path: "/mybets",
  },
  {
    name: "Get started",
    path: "/signup",
  },
];

export const MobileNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const [active, setActive] = useState(null);

  const handleActive = (id) => {
    setActive(id);
  };

  return (
    <div className="landing-row">
      <div className="flex justify-between items-center">
        <img src={logo} className="img-fluid logo" alt="logo" />
        <div className="mt-2" onClick={toggleMenu}>
          <LuMenu size={30} />
        </div>
      </div>
      {menuOpen && (
        <div className="bg-[#FFF] w-full mt-4">
          {menu.map((elem, index) => (
            <p
              onClick={() => {
                navigate(elem.path);
              }}
              key={index}
              className={
                active === index
                  ? "mt-2 text-[#7E00CC] text-[17px] font-medium"
                  : "mt-2 text-[#2B4255] text-[17px] font-medium"
              }
            >
              {elem.name}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
